import React from "react";
import PropTypes from "prop-types";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const tagStyle = {
  fontFamily: "Nunito",
  fontSize: 11,
  fontWeight: 700,
  color: "#374151",
  background: "#f3f4f6",
  borderRadius: 20,
  padding: "3px 10px",
  whiteSpace: "nowrap",
};

const Cards = ({ data }) => {
  const history = useNavigate();

  if (!data) return null;

  const tags = (data.interestedDomains || []).slice(0, 5);

  return (
    <div style={{
      background: "#ffffff",
      border: "1px solid #e5e7eb",
      borderRadius: 12,
      padding: "18px 20px",
      display: "flex",
      flexDirection: "column",
      gap: 14,
    }}>
      {/* Avatar + name */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <Avatar
          src={data.profilePic}
          style={{ width: 52, height: 52, border: "1px solid #e5e7eb", flexShrink: 0 }}
        />
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontFamily: "Nunito", fontWeight: 700, fontSize: 15, color: "#111827", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {data.name}
          </p>
          <p style={{ margin: "3px 0 0", fontFamily: "Nunito", fontSize: 13, color: "#6b7280" }}>
            {data.location?.country || ""}
          </p>
        </div>
      </div>

      {/* Tags */}
      {tags.length > 0 && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
          {tags.map((tag, i) => <span key={i} style={tagStyle}>{tag}</span>)}
        </div>
      )}

      {/* View button */}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <button
          onClick={() => history(`/admin/verify-investor/${data.id}`, { state: { investor: data } })}
          style={{ background: "#111827", color: "#fff", border: "none", borderRadius: 8, padding: "8px 18px", fontFamily: "Nunito", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
          onMouseEnter={e => (e.currentTarget.style.background = "#374151")}
          onMouseLeave={e => (e.currentTarget.style.background = "#111827")}
        >
          View →
        </button>
      </div>
    </div>
  );
};

Cards.propTypes = { data: PropTypes.any.isRequired };
export default Cards;
